import React, {Component} from 'react';

import { initAmplitude, logSocialLinkClickEvent, logSocialShareViewEvent, logCtaClickEvent, getAmplitudeDeviceId, logDownloadAppClickEvent } from '../../../shared/redux/amplitude';

import { Campaign, CampaignPreviewCard}  from 'dabbl-react-components';
import { parseQueryString } from '../../../shared/utils';
import {trackSocialShare} from "../../../shared/redux/entities/actions";

class PreviewCampaign extends Component {
  constructor(props) {
    super(props);
    const query = parseQueryString(this.props.location.search);
    this.state = {
      isPreviewShown: false, 
      isLoading: true, 
      downloadLinkOnConclusion: query.downloadLink,
      hideTile: query.hideTile === 'true',
      autoPlay: query.autoPlay === 'true'
    }
  }

  componentDidMount() {
    if (this.state.downloadLinkOnConclusion) {
      initAmplitude()
    }
    Promise.resolve()
      .then(() => this.props.getPreviewCampaign(this.props.previewToken))
      .then(campaign => {
          this.setState({isLoading: false, campaign: campaign})
          if (campaign) {
            this.trackPreviewView(campaign)
          }
        }
      )
      .catch(() => this.setState({isLoading: false}))
    window.onpopstate = (e) => {
      if (!this.state.isPreviewShown){ return }
      this.setState({isPreviewShown: false})
    }
  }

  handlePreviewClick() {
    window.history.pushState({}, null, '#content');
    this.setState({isPreviewShown: true})
  }

  backToPreview() {
    window.history.back();
  }

  onShareButtonClick(network) {
    if (this.state.downloadLinkOnConclusion) {
      return
    }
  }

  onSkipClick() {
    if (this.state.downloadLinkOnConclusion) {
      return
    }
    this.backToPreview()
  }

  trackPreviewView(campaign){
    logSocialLinkClickEvent(campaign.name)
    this.props.trackSocialShare(campaign.id, 'start')
  }

  trackConclusionView(campaign){
    logSocialShareViewEvent(campaign.name)
    this.props.trackSocialShare(campaign.id, 'end')
  }

  trackDownloadAppClick(from, platform, url){
    logDownloadAppClickEvent(from, platform, url)
  }

  onConclusionLinkClick(url){
    const {campaign} = this.state;
    logCtaClickEvent(campaign.name, campaign.id, campaign.brandName, url)
    this.props.trackSocialShare(campaign.id, 'click', getAmplitudeDeviceId())
  }

  render() {
    const {isPreviewShown, isLoading, campaign, hideTile, autoPlay} = this.state;
    console.log('hideTile', hideTile);
    console.log('autoPlay', autoPlay);
    if (isLoading) {
      return <div> Loading... </div>
    }
    if (!campaign) {
      return <div>Can't load campaign...</div>
    }

    return (
      <div className='vertical-center' style={{height: "100%"}}>
        {isPreviewShown || hideTile ? (
          <div className="PreviewCampaign">
              <Campaign
                campaign={campaign}
                retailerName= { hideTile ? 'Tapjoy' : 'Dabbl' }
                hideTotalValue
                showToast={ !this.state.downloadLinkOnConclusion && !hideTile }
                usePoints={true}
                hideToastCopy={true}
                autoPlayVideo={autoPlay}
                downloadLinkOnConclusion={this.state.downloadLinkOnConclusion}
              onCloseCampaign={() => this.backToPreview()}
              onShareButtonClick={(network) => this.onShareButtonClick(network)}
              onSkipShareCampaign={()=>this.onSkipClick()}
              onAllEngagementsAnswered={()=> this.state.downloadLinkOnConclusion && this.trackConclusionView(campaign)}
              onConclusionLinkClick={(url)=>this.onConclusionLinkClick(url)}
              onDownloadAppClick={(from, platform, url) => {this.trackDownloadAppClick(from, platform, url)}}
            />
          </div>
          ) : (
           <div className="PreviewCampaign_PreviewCard">
             <CampaignPreviewCard
              brandName={campaign.brandName}
              retailerName='Dabbl'
              downloadLink={this.state.downloadLinkOnConclusion}
              totalValue={campaign.totalValue}
              imgSrc={campaign.feedimageurl}
              isNewDesign={true}
              isPreviewMode={true}
              usePoints={true}
              text={campaign.feedtext}
              textSecondary={ this.state.downloadLinkOnConclusion === undefined ? `from ${campaign.brand.name}` : `provided by ${campaign.brand.name}`}
              onClick={() => this.handlePreviewClick()}
              onDownloadAppClick={(from, platform, url) => {this.trackDownloadAppClick(from, platform, url)}}
            />
           </div>
          )
        }
      </div>
    );
  }
}

export default PreviewCampaign;



// WEBPACK FOOTER //
// ./src/routes/PreviewCampaign/components/PreviewCampaign.js